import { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SkeletonProps {
  children?: ReactNode;
  className?: string;
  active?: boolean;
}

/** Renders a pulsing placeholder sized to match `children`'s own layout box, by laying `children` out invisibly and overlaying the placeholder on top. */
export function Skeleton({
  children,
  className,
  active = true,
}: SkeletonProps) {
  if (!active) return children;

  return (
    <div className={twMerge("relative inline-block max-w-full", className)}>
      <div className="invisible">{children}</div>
      <div
        className={twMerge(
          "bg-surface-hover absolute inset-0 max-h-16 animate-pulse rounded-full",
          className,
        )}
      />
    </div>
  );
}
